import axios from "axios";
import toast from "react-hot-toast";
import store from "../Redux/store";
import { clearUser } from "../Redux/userActions";

const getLocalStorage = (key) => {
  if (typeof window === "undefined" || !window.localStorage) return null;
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;
  try {
    const item = JSON.parse(itemStr);
    if (!item.expiry) return item.value;
    const now = new Date();
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (err) {
    return itemStr;
  }
};

const axiosInstance = axios.create({
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token =
      store.getState()?.user?.token ||
      getLocalStorage("paramToken") ||
      (typeof localStorage !== "undefined" && localStorage.getItem("token"));
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      if (window.location.pathname !== "/login") {
        sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
      }
      toast.error("Session expired. Please log in again.");
      store.dispatch(clearUser());
      window.location.href = "/login";
      return Promise.reject(error);
    }

    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.error ||
      error?.message ||
      "Something went wrong";

    toast.error(message);

    return Promise.reject(error);
  },
);

export default axiosInstance;
